import { Component, OnInit, OnDestroy } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { isThisHour } from 'date-fns/esm';
import { CommonService } from 'src/app/core/common.service';
import { DataPopulationEvents, ImmigrationDataPopulationService } from 'src/app/immigration/services/data-population/ImmigrationDataPopulation.service';

@Component({
    selector: 'eos-formly-field-button',
    templateUrl: './formly-button.component.html',
    styleUrls: ['./formly-button.component.css']
})
export class FormlyFieldButtonComponent extends FieldType implements OnInit {


    constructor(

    ) {
        super();
    }

    ngOnInit() {
    }

    /**Triggered subjects should be reset
     * to initial value since its inside Singleton services
     * */

    onClick($event) {

        if (this.to.onClick) {
            this.to.onClick($event);
        }

    }


}
